import { defineComponent, unref, resolveComponent, computed } from 'vue';import { useStore } from 'vuex';import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue";
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import { getLinkUrlInfo } from '@/utils/index';
import { setLocalItem } from '@/utils/localStorage';
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {
    const locale = zhCn;
    const {
      state
    } = useStore();
    const isRouterAlive = computed(() => state.moduleCommon.isRouterAlive);
    const hasMctCode = getLinkUrlInfo('mctcode');
    // 获取用户访问是否从渠道链接进来
    if (hasMctCode) {
      setLocalItem('zl-mctcode', hasMctCode);
    }
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_config_provider = _resolveComponent("el-config-provider");
      return _openBlock(), _createBlock(_component_el_config_provider, {
        locale: _unref(locale)
      }, {
        default: _withCtx(() => [_unref(isRouterAlive) ? (_openBlock(), _createBlock(_component_router_view, {
          key: 0
        }, {
          default: _withCtx(({
            Component
          }) => [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["locale"]);
    };
  }
});